import { css, styled } from 'canoe';
import React from 'react';

type Props<T extends React.ElementType> = {
  children?: React.ReactNode;
  innerRef?: React.Ref<any>;
  is?: T;
  css?: any;
  [key: string]: any;
} & React.ComponentProps<T>;

export const StyledNode = <T extends React.ElementType>(el: Props<T>) => styled(el)`
  ${({ theme }) => css`
    user-select: none;

    &:hover,
    .hovered {
      position: relative;
      outline: 1px dashed ${theme.colors.BrandPurpleL20} !important;
    }

    .selected,
    .draggedOver {
      outline: 1px solid ${theme.colors.BrandPurpleL10} !important;

      &--collection {
        outline: 1px solid ${theme.colors.MangoOrangeD10} !important;
      }
    }

    .collection {
      &:hover {
        outline: 1px dashed ${theme.colors.MangoOrangeD10} !important;
      }
    }
  `}
`;
